<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system/index';
	import ButtonFindMe from 'src/components/DevicesSettings/SettingsGBLE/ButtonFindMe.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<SidepanelContent>
	<ButtonFindMe {device} />
</SidepanelContent>
